module.exports = __webpack_public_path__ + "static/media/17_blanco.c68b8211.svg";